// extracted by mini-css-extract-plugin
module.exports = {"form-group":"SimpleCheckBox_form-group__HGXin","label-wrapper":"SimpleCheckBox_label-wrapper__3g1Lh"};